// extracted by mini-css-extract-plugin
export default {"wrapper":"pageWrapper_wrapper__TGxM7","inner":"pageWrapper_inner__v62+V"};